<script setup lang="ts">
import { Logout } from 'ui-kit'
import EnvironmentSelector from '@/components/admin/EnvironmentSelector.vue'
import { useAuthStore } from '@/store/auth'

const auth = useAuthStore()

function onLogout() {
  auth.logout()
}
</script>

<template>
  <div class="admin-layout">
    <header class="admin-layout__header">
      <div class="admin-layout__header-left">
        <h1 class="admin-layout__title">First IMS Admin</h1>
      </div>
      <div class="admin-layout__header-right">
        <EnvironmentSelector />
        <Logout @logout="onLogout" />
      </div>
    </header>
    <main class="admin-layout__main">
      <slot />
    </main>
  </div>
</template>

<style scoped>
.admin-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fafaf9;
}

.admin-layout__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #e7e5e4;
  flex-shrink: 0;
}

.admin-layout__header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.admin-layout__title {
  font-size: 18px;
  font-weight: 600;
  color: #1c1917;
  margin: 0;
}

.admin-layout__header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.admin-layout__main {
  flex: 1;
  padding: 24px;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}
</style>
